import React from 'react'
import SEOHead from '../components/SEOHead'
import MainTrailers from '../components/MainTrailers'

const TrailersPage: React.FC = () => {
  return (
    <div>
      <SEOHead
        title="Boat Trailers - Aluminum, Galvanized, Bunk & Roller | Fast Boat Trailers"
        description="Complete selection of boat trailers at Fast Boat Trailers in Edgewater, MD. Aluminum, galvanized, bunk, roller, pontoon, PWC, and skiff trailers. USA-made Venture trailers for all boat types."
        keywords="boat trailers Maryland, aluminum trailers, galvanized trailers, bunk trailers, roller trailers, Venture trailers, pontoon trailers, PWC trailers"
        ogTitle="Boat Trailers - Complete Selection | Fast Boat Trailers"
        ogDescription="Complete selection of boat trailers - aluminum, galvanized, bunk, roller, pontoon, PWC, and skiff trailers. USA-made Venture trailers."
        ogImage="/images/logos/fbt-logo-3-noborder.jpeg"
        canonical="https://fastboattrailers.com/trailers"
      />
      <MainTrailers />
    </div>
  )
}

export default TrailersPage